(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PartnersStatisticsController', PartnersStatisticsController);

    PartnersStatisticsController.$inject = ['$uibModalInstance','statistics','partner'];


    function PartnersStatisticsController($uibModalInstance, statistics, partner) {
        var vm = this;
        vm.ok      = ok;
        vm.cancel  = cancel;
        vm.statistics               = statistics;
        vm.percentage               = percentage;
        vm.percentageQuality        = percentageQuality;
        vm.formatPercent            = formatPercent;
        vm.dateFormat               = dateFormat;
        vm.formatAreaXLabel         = formatAreaXLabel;
        vm.formatAreaYLabel         = formatAreaYLabel;
        vm.registrationsGraph       = [];
        vm.changeRegisteredGraph    = changeRegisteredGraph;
        vm.quality                  = quality;
        vm.partner                  = partner;

        function activate() {
            console.log(vm.statistics.locations[vm.statistics.first_location].registrations);
            changeRegisteredGraph(vm.statistics.locations[vm.statistics.first_location].registrations);
        }

        function ok () {
            $uibModalInstance.close();
        }


        function cancel () {
            $uibModalInstance.close();
        }

        function quality(family){
            if(vm.students.total){
                return (parseInt(family)*100 / vm.students.total).toFixed(2);
            }
            return 0;
        }

        function percentage(qtd,total)
        {
            if(qtd > 0){
                return (parseInt(qtd)*100 / total).toFixed(2);
            }
            return 0;
        }

        function percentageQuality(qtd,total)
        {
            if(qtd > 0 && total > 0){
                return ((parseInt(qtd) / parseInt(total))*100).toFixed(2);
            }
            return 0;
        }

        function formatPercent(input)
        {
            return input + '%';
        }

        function dateFormat(date) {
            return date.getDate()+'/'+(date.getMonth()+1)+'/'+date.getFullYear();
        }

        function formatAreaXLabel(input) {
            //return (input.src.x + ' days before').toString();
            return (input.src.x).toString();
        }

        function formatAreaYLabel(input) {
            return parseInt(input);
        }

        function changeRegisteredGraph(registrations){
            vm.registrationsGraph = registrations.slice().reverse();
        }

        activate();

    }

})();